<template>
  <div id="app">
    <div class="main-content-wrapper">
      <!-- Main content for each page -->
      <div class="main-content">
        <router-view />
      </div>
    </div>
    <TheFooter v-if="!isLoginPage" />
  </div>
</template>

<script>
import TheFooter from "./components/Layout/TheFooter.vue";
import { useRoute } from "vue-router";

export default {
  name: "App",
  components: {
    TheFooter,
  },
  setup() {
    const route = useRoute();
    const isLoginPage = route.name === "Login" || route.path === "/";
    return {
      isLoginPage,
    };
  },
};
</script>

